module.exports = __webpack_public_path__ + "static/media/hacker2-dots.f3b642c9.svg";